<template>
  <div id="app">  
    <!--<router-view/>-->
<keep-alive>
    <router-view v-if="$route.meta.keepAlive=='1'"></router-view>
</keep-alive>
<router-view v-if="$route.meta.keepAlive!='1'"></router-view>	
  </div>
</template>

<script>
export default {
  name: 'App' 
}
</script>

<style>
	body{
		margin: 0;
	}
	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		height: 100vh;
		background: #f3f3f3;
		position: relative;
	}
	.loading-mask {
		position: fixed!important;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue